import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { BlogService } from '../data-access-blog/blog.service';
import { BlogCategory } from '../domain';
import { BlogNavComponent } from '../ui-blog-nav/blog-nav.component';

@Component({
  selector: 'rma-blog',
  templateUrl: './blog-layout.component.html',
  styleUrls: ['./blog-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BlogNavComponent, RouterOutlet, AsyncPipe],
})
export class BlogLayoutComponent implements OnInit {
  public categories$: Observable<BlogCategory[]>;

  public constructor(private readonly blogService: BlogService) {}

  public ngOnInit(): void {
    this.categories$ = this.blogService.getAllCategories();
  }
}
